import { IPersonalInfoResponse } from './personalInfo.interface';
import { ClientConfig } from '../../app/appState.interface';

export enum PersonalInfoActionTypes {
    UPDATE_REQUEST = 'USERS_UPDATE_REQUEST',
    UPDATE_SUCCESS = 'USERS_UPDATE_SUCCESS',
    UPDATE_FAILURE = 'UPDATE_FAILURE',
    DOB_SET = 'DOB_SET',
}

export type PersonalInfoAction =
    | {
          type: PersonalInfoActionTypes.UPDATE_REQUEST;
      }
    | {
          type: PersonalInfoActionTypes.UPDATE_SUCCESS;
          memberInfo: IPersonalInfoResponse;
          clientConfig: ClientConfig;
          meta: { rat: Record<string, any> };
      }
    | {
          type: PersonalInfoActionTypes.DOB_SET;
          date: string;
      }
    | {
          type: PersonalInfoActionTypes.UPDATE_FAILURE;
          payload: {};
      };
